import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { KeyUri } from '../key';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import Bookingpdf from './Bookingpdf'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import {storage} from '../firebaseconfig';
const BookingConfirmed = () => {
  const location = useLocation();
  const { paymentId, rideid } = location.state || {};
  const [booking_details, set_booking_details] = useState({})
  const [payment_details, set_payment_details] = useState({})

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      if (!paymentId || !rideid) return;
  
      try {
        // Step 1: Fetch payment details
        const response = await axios.get(`${KeyUri.BACKEND_URI}/payment/check-payment/${paymentId}`);
        const paymentData = response?.data;
        set_payment_details(paymentData);
  
        // Step 2: Fetch booking details
        const received_data = await axios.get(`${KeyUri.BACKEND_URI}/get-booking/${rideid}`);
        set_booking_details(received_data?.data);
  
        // Step 3: Update booking with payment details
        const values = {
          payment_status: paymentData.status,
          payment_method: paymentData.method,
          payment_amount: paymentData.amount,
          payment_date: new Date(paymentData.created_at * 1000),
          payment_id: paymentId
        };
        await axios.put(`${KeyUri.BACKEND_URI}/update-booking/${rideid}`, values);
  
        // Step 4: Generate and upload PDF
        const blob = await pdf(
          <Bookingpdf invoiceData={received_data?.data} payment={paymentData} />
        ).toBlob();
  
        const fileRef = ref(storage, `booking-pdfs/booking_${rideid}.pdf`);
        const uploadResult = await uploadBytes(fileRef, blob);
        const downloadURL = await getDownloadURL(uploadResult.ref);
        console.log("PDF uploaded to Firebase Storage at:", downloadURL);
  
        // Step 5: Now send alert and invoice link AFTER updating and uploading
        await axios.post(`${KeyUri.BACKEND_URI}/bookingalert`, { booking_idd: rideid });
        await axios.post(`${KeyUri.BACKEND_URI}/sendinvoice`, { booking_idd: rideid });
  
      } catch (e) {
        console.error("Error:", e);
      }
    };
  
    fetchPaymentDetails();
  }, [paymentId, rideid]);
  
  
  const date_in_normal_form = (rideDate) => {
    // Convert the rideDate string to a Date object
    const rideDateObj = new Date(rideDate);

    // Options to format the date
    const options = {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };

    // Format the date to the desired format "Sunday, dd-mm-yyyy"
    const formattedDate = rideDateObj
      .toLocaleDateString("en-GB", options)
      .replace(",", " - ");

    return formattedDate;
  };
  const handleDownloadPDF = async () => {
    console.log("all booking details " + booking_details)
    const blob = await pdf(<Bookingpdf invoiceData={booking_details} payment={payment_details} />).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "Booking_Confirmation.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {(paymentId || rideid) ? <div className="min-h-screen bg-gray-50 mb-16">
        <div className="bg-green-50 p-4 border-b border-green-200">



          {((payment_details?.status === "captured") ? <div className="max-w-4xl mx-auto flex items-center gap-2 text-green-700 content-center ">
            <span>Booking Confirmed Successfully!</span>
          </div> : <div className="max-w-4xl mx-auto flex items-center gap-2 text-red-700">
            <span>Payment Under Process</span>
          </div>)}

        </div>
        {console.log("Here Is the Payment", payment_details)}
        <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8 space-y-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <h1 className="text-2xl font-semibold">Booking Details

            </h1>
          </div>
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-lg font-medium mb-4">Main Passenger Details</h2>
              <div className="space-y-2">
                {console.log("booking_details", (booking_details))}
                <div><span className="font-medium">Name: </span>{booking_details?.userid?.name}</div>
                <div><span className="font-medium">Email: </span>{booking_details?.userid?.email}</div>
                <div><span className="font-medium">Phone: </span> {booking_details?.userid?.phone_number}</div>
              </div>
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-4 py-5 sm:p-6">
                <h2 className="text-lg font-medium mb-4">Journey Details</h2>
                <div className="space-y-2">
                  <div><span className="font-medium">From:</span> {booking_details?.route?.from_location?.name}</div>
                  <div><span className="font-medium">To:</span> {booking_details?.route?.to_location?.name}</div>
                  <div><span className="font-medium">Date of Trip: </span>{date_in_normal_form(booking_details?.ride_date_and_time)}</div>
                </div>
              </div>
            </div>
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-4 py-5 sm:p-6">
                <h2 className="text-lg font-medium mb-4">Location Details</h2>
                <div className="space-y-2">
                  <div><span className="font-medium">Pickup:</span> {booking_details?.pickup_point}</div>
                  <div><span className="font-medium">Drop:</span>  {booking_details?.drop_point}</div>
                  <div><span className="font-medium">Seats Booked:</span> {booking_details?.selected_seats?.join(" , ")}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <h2 className="text-lg font-medium mb-6">Vehicle Details</h2>
              <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-2">
                <div className="relative h-48 w-full">
                  <img
                    src={booking_details?.vehicleId?.picture_of_the_vehicle}
                    alt="Toyota Innova"
                    className="rounded-lg object-cover h-full w-full"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-4">{booking_details?.data?.vehicleId?.brand_name} {booking_details?.data?.vehicleId?.model_name}</h3>
                  <ul className="space-y-2">
                    <li>• Air Conditioned Luxury Vehicle</li>
                    <li>• Comfortable & Spacious Seating</li>
                    <li>• Female Passenger Safety Standards</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
                <span className="text-lg font-medium">Total Amount Paid:</span>
                <span className="text-2xl font-semibold">₹ {(payment_details?.amount)}/-</span>
              </div>
            </div>
          </div>
          {/* <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
                <span className="text-lg font-medium">
                  Ride has been booked, and driver details will be shared 24 hours before the ride begins.
                </span>   
                         
                </div>
            </div>
          </div> */}
          <div className="bg-indigo-50 shadow rounded-lg overflow-hidden">
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-center justify-between">
               {(payment_details?.status==="captured" ? <span className="text-lg font-medium">
                  Ride has been booked, and driver details will be shared 24 hours before the ride begins.
                </span> : <span className="text-lg font-medium">
                  Payment Under Process
                </span>  )} 
                         
                </div>
            </div>
          </div>
          <button 
              onClick={handleDownloadPDF} 
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg"
            >
              Download Invoice
            </button>
        </div>
      </div> : <h1>You are Not allowed To View This page</h1>}

    </>
  )
}

export default BookingConfirmed;
